export default "__VITE_ASSET__BocFQMyA__"